import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { LogoText } from '../ui/Logo';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '../ui/sheet';

const PUBLIC_LINKS = [
  { to: '/integrations', key: 'public.integrations' },
  { to: '/pricing', key: 'public.pricing' },
  { to: '/docs', key: 'public.docs' },
  { to: '/blog', key: 'public.blog' },
] as const;

export default function MarketingHeader() {
  const { t } = useTranslation('navigation');
  const { t: authT } = useTranslation('auth');
  const [open, setOpen] = useState(false);

  return (
    <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between gap-3">
          <Link to="/" className="inline-flex min-w-0 items-center">
            <LogoText variant="dark" size="md" iconSize={32} className="text-foreground" />
          </Link>
          <nav className="hidden items-center gap-1 md:flex" aria-label={t('mainNavAriaLabel')}>
            {PUBLIC_LINKS.map((link) => (
              <Button key={link.to} variant="ghost" size="sm" asChild className="min-h-[44px]">
                <Link to={link.to}>{t(link.key)}</Link>
              </Button>
            ))}
            <Button asChild size="sm" className="min-h-[44px]">
              <Link to="/login">{authT('signIn')}</Link>
            </Button>
          </nav>
          <div className="flex items-center gap-2 md:hidden">
            <Button asChild size="sm" className="min-h-[44px]">
              <Link to="/login">{authT('signIn')}</Link>
            </Button>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="min-h-[44px] min-w-[44px]"
                  aria-label={t('openMainMenu')}
                >
                  <Menu className="h-5 w-5" aria-hidden />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-full max-w-sm">
                <SheetHeader className="sr-only">
                  <SheetTitle>{t('mainNavAriaLabel')}</SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col gap-2 pt-8" aria-label={t('mainNavAriaLabel')}>
                  {PUBLIC_LINKS.map((link) => (
                    <Button key={link.to} variant="ghost" asChild className="justify-start min-h-[44px]">
                      <Link to={link.to} onClick={() => setOpen(false)}>
                        {t(link.key)}
                      </Link>
                    </Button>
                  ))}
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
}
